import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popin-footer',
  templateUrl: './popin-footer.component.html',
  styleUrls: ['./popin-footer.component.scss']
})
export class PopinFooterComponent implements OnInit {

  constructor() { }
  show=false;

  ngOnInit(): void {
  }

}
